import { FC } from "react";
import Lottie from "react-lottie-player";
import LoadingLukiao from "../assets/animations/loading.json";
import React from "react";

const Loading: FC = () => {
  return (
    <>
      <div
        style={{
          zIndex: 10000,
          backgroundColor: "RGB(205, 71, 205, 0.2)",
          position: "fixed",
          top: "50%",
          left: "50%",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          height: "100%",
        }}
      >
        <Lottie
          loop
          animationData={LoadingLukiao}
          play
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      </div>
    </>
  );
};

export default Loading;
